//import markerImageGreen from "../images/map-marker_green.png";
//import markerImageDarkBlue from "../images/map-marker_dark-blue.png";
//import markerImageCornflowerBlue from "../images/map-marker_cornflower-blue.png";
//import markerImageGreenYellow from "../images/map-marker_green-yellow.png";

import markerImageCyan from "../images/map-marker_cyan.png";//source
import markerImageGreen from "../images/map-marker_green.png";//destination
import markerImageOrange from "../images/map-marker_orange.png";//sourceClick
import markerImageRed from "../images/map-marker_red.png";//destinationClick
import markerImagePurple from "../images/map-marker_purple.png";//sourceDestination
import markerImageYellow from "../images/map-marker_yellow.png";//sourceDestinationClick

let strokeWeight = 2;
let maxWidthPopup = 400;
let objectMap = {};
let zIndex = 1;
let curveClickColor = '#e2c005';
let curveDefaultColor = '#49b033';
let markerColor = {
  "source": markerImageCyan,
  "destination": markerImageGreen,
  "sourceDestination": markerImageYellow,
  "sourceClick": markerImageOrange,
  "destinationClick": markerImageRed,
  "sourceDestinationClick": markerImagePurple
}
let coordinate = { "destination": 0, "source": 1 };
let receiver = { "source": 0, "destination": 1 };
let icon = { "default": 0, "clicked": 1 };
let tempImage = "";
let zoomArea = 5;

//let infoWindowContent = {receiverPID: id, receiverName: receiverNameDetails, receiverAccount:receiverAccountDetails, receiverGroupName: receiverGroupNameDetails, totalLiveId:total, incoming: Incoming, incomingDetails : incomingDetails,   outgoing:outcoming , outcomingDetails: outcomingDetails };
//let infoWindowContent = {receiverPID:"", receiverName:"", receiverAccount:"", receiverGroupName:"", totalLiveId:"", incoming:"", incomingDetails:"",  outgoing:outcoming , outcomingDetails:"" };
let infoWindowContent = {};

/*
// DashBoardMap object for creating marker and curve
*/
function dashBoardMap(_id, _objectLongLititue) {
  this.id = _id;
  this.objectLongLititue = _objectLongLititue;
  var Map = google.maps.Map;
  this.LatLngBounds = google.maps.LatLngBounds;
  const zoom = Math.ceil(Math.log2(window.innerWidth)) - 8
  var mapOptions = {
    center: new google.maps.LatLng(0, 0),
    zoom: zoom
  };
  this.zoomLevel = zoom;
  //console.log("zoom --> ", zoom);
  this.map = new Map(document.getElementById(_id), mapOptions);
  this.markers = [];
  this.arrowMarker = [];
  this.linePath = [];
  // this.infoData = []
  // this.infoData["incomingDetails"] = new Array();
  // this.infoData["outcomingDetails"] = new Array();
  // this.infoData["incoming"] = new Array();
  // this.infoData["outcoming"] = new Array();
  // this.infoData["liveTime"] = new Array();
  // this.infoData["receiverNameDetails"] = new Array();
  // this.infoData["receiverAccountDetails"] = new Array();
  // this.infoData["receiverGroupNameDetails"] = new Array();
  this.setDefaultInfoData();
  this.dataMarkerInstance = [];
  this.latLngData = {};
  this.rpidData = {};// overlapping marker collection  at instance property i.e. self.rpidData[rpid]['instance']
  this.overLappingMarkerPopUp = null;
  this.purpleColor = []; /*  purple only when same lat and lnt with same pid */
  this.infoWindowMarker = null;
  this.clickedMarkerDetails = {};
}

/*
//Get the active click marker details 
*/
dashBoardMap.prototype.getClickedMarkerDetails = function () {
  return this.clickedMarkerDetails;
}

/*
//Set the active click marker details
*/
dashBoardMap.prototype.setClickedMarkerDetails = function (_markerDetails) {
  this.clickedMarkerDetails = _markerDetails;
}

/*
//Clear marker details 
*/
dashBoardMap.prototype.clearClickedMarkerDetails = function () {
  this.clickedMarkerDetails = {};
}

/*
//Clear marker details 
*/
dashBoardMap.prototype.test = function () {
  return this.dataMarkerInstance[2].marker1;
}

/*
// set Default value at InfoData
*/
dashBoardMap.prototype.setDefaultInfoData = function () {
  this.infoData = [];
  this.infoData["incomingDetails"] = [];
  this.infoData["outcomingDetails"] = [];
  this.infoData["incoming"] = [];
  this.infoData["outcoming"] = [];
  this.infoData["liveTime"] = [];
  this.infoData["receiverNameDetails"] = [];
  this.infoData["receiverAccountDetails"] = [];
  this.infoData["receiverGroupNameDetails"] = [];
}

/*
// Increment the lat and lng by 1
*/
dashBoardMap.prototype.incrementByLatLng = function (_latLng, _instance) {

}

/*
// list by lat and lng
*/
dashBoardMap.prototype.listLatLng = function (_latLng, _rPID) {

  //console.log(" dashBoardMap.prototype.listLatLng  _latLng  , _rPID ----> ", " _latLng ",  _latLng, ", _rPID ", _rPID);

  if (this.latLngData[_latLng]) {
    //console.log("this.latLngData[_latLng].length ---------------------------------> ", this.latLngData[_latLng].length);
    if (!this.latLngData[_latLng].includes(_rPID)) {
      this.latLngData[_latLng].push(_rPID);
    }
  }
  else {
    this.latLngData[_latLng] = [];
    this.latLngData[_latLng].push(_rPID);
  }

  //for testing
  //this.latLngData["37-97"] = ["39d106d4b31asdasde0", "39d106d4b3150be0"];
  //this.latLngData["37.751-97.822"] = ["39d106d4b31asdasde0", "39d106d4b3150be0"];
}

/*
// Increment on basis of RPID (either LivePeerID or peerID)
*/
dashBoardMap.prototype.incrementRPID = function (_rPId, _index) {
  if (this.rpidData[_rPId] && this.rpidData[_rPId]['total']) {
    this.rpidData[_rPId]['total'] = this.rpidData[_rPId]['total'] + 1;
    this.rpidData[_rPId]['instance'].push(_index);
  }
  else {
    this.rpidData[_rPId] = {};
    this.rpidData[_rPId]['total'] = 1; // total no. of RPID
    this.rpidData[_rPId]['instance'] = [_index]; // list of total no. of RPID, it contains the ref index of this.dataMarkerInstance
    this.rpidData[_rPId]['click'] = 0;
    this.rpidData[_rPId]['totalInOutLine'] = []; // total no. of in and out line
  }
}

/*
// Remove the marker 
*/
dashBoardMap.prototype.removeMarker = function () {
  const dataMarkerInstance = this.dataMarkerInstance;
  if (dataMarkerInstance && dataMarkerInstance.length) {
    const total = dataMarkerInstance.length;
    for (let inc = 0; inc < total; inc++) {
      const instance = dataMarkerInstance[inc];

      //console.log("instance.marker1----> ", instance.marker1);
      //console.log("this.clickedMarkerDetails ---> ", this.clickedMarkerDetails);

      if (instance && instance.marker1) instance.marker1.setMap(null);
      if (instance && instance.marker2) instance.marker2.setMap(null);
    }
  }
  // empty array
  this.dataMarkerInstance = [];
}

/*
// Remove the Line/Curve 
*/
dashBoardMap.prototype.removeCurve = function () {
  const linePath = this.linePath;
  if (linePath && linePath.length) {
    const total = linePath.length;
    for (let i = 0; i < total; i++) {
      const linePathObj = linePath[i];
      if (linePathObj) linePathObj.setMap(null);
    }
  }
  // empty array 
  this.linePath = [];
}

/*
// Empty popup data  
*/
dashBoardMap.prototype.emptyPopupData = function () {
  this.latLngData = {};
  this.setDefaultInfoData();
  this.rpidData = {};
  this.purpleColor = []
}

/*
// Clear collection 
*/
dashBoardMap.prototype.clearCollection = function () {
  this.emptyPopupData();
  this.removeMarker();
  this.removeCurve();
}

/*
// Create marker on the basis of lat and lng 
*/
dashBoardMap.prototype.createMarker = function (_coordinates, _index) {
  let marker1 = null;
  let marker2 = null;
  marker1 = this.setMarkerByReceiver(_coordinates, coordinate.destination, _index);
  marker2 = this.setMarkerByReceiver(_coordinates, coordinate.source, _index, marker1);

  this.dataMarkerInstance[_index] = {
    marker1: marker1,
    marker2: marker2,
    marker1Coordinates: _coordinates[coordinate.destination],
    marker2Coordinates: _coordinates[coordinate.source],
    clickLine: 0,
    liveTime: _coordinates[coordinate.destination].liveTime,
    liveStartTime: _coordinates[coordinate.destination].liveStartTime,
    activeMarkerId: null,
    activeInstance: "",
    clickMarker: -1,
    activePopupInstance: "",
  };
}

/*
//Set marker1 i.e. destination or marker2 i.e. source
*/
dashBoardMap.prototype.setMarkerByReceiver = function (_coordinates, _receiverIndex, _index, _marker = null) {
  //console.log("_index --> ", _index);
  let Marker = google.maps.Marker;
  let marker = null;

  try {

    if (_coordinates[_receiverIndex]) {
      let rPId = _coordinates[_receiverIndex].id;

      zIndex++;
      let propMarker = {
        position: _coordinates[_receiverIndex],
        icon: _receiverIndex == coordinate.destination ? markerColor.destination : markerColor.source,
        map: this.map,
        zIndex: zIndex
      };
      marker = new Marker(propMarker);

      this.incrementRPID(_coordinates[_receiverIndex].id, _index);

      //todo : do not use the make array at below line  when marker1 and marker2 both have same lat and lng with different pid
      /*
      if(_receiverIndex == coordinate.source && _coordinates.id  ){
        _coordinates[coordinate.source] == _coordinates[coordinate.destination]
      }
      if(_receiverIndex == coordinate.destination ){
        this.listLatLng(_coordinates[_receiverIndex].lat + "" + _coordinates[_receiverIndex].lng, _coordinates[_receiverIndex].id);
      }*/

      let sourceLatLng = "";
      if(_coordinates[coordinate.source]){
        sourceLatLng = _coordinates[coordinate.source].lat + "" + _coordinates[coordinate.source].lng ;
      }
      let destinationLatLng = "";
      if(_coordinates[coordinate.destination]){
        destinationLatLng = _coordinates[coordinate.destination].lat + "" + _coordinates[coordinate.destination].lng ;
      }

      if(_receiverIndex == coordinate.destination ){
        if(sourceLatLng !== destinationLatLng ){
          this.listLatLng(_coordinates[_receiverIndex].lat + "" + _coordinates[_receiverIndex].lng, _coordinates[_receiverIndex].id);
        }
      }else{
        this.listLatLng(_coordinates[_receiverIndex].lat + "" + _coordinates[_receiverIndex].lng, _coordinates[_receiverIndex].id);
      }
      //this.listLatLng(_coordinates[_receiverIndex].lat + "" + _coordinates[_receiverIndex].lng, _coordinates[_receiverIndex].id);


      // Show unique marker (or first marker ) by hiding same marker based on rpid
      if (this.rpidData && this.rpidData[rPId] && this.rpidData[rPId]["total"] > 1) {
        //console.log("_index --> ", _index);
        marker.setVisible(false);

        //update icon violet for grouping
        if (this.rpidData && this.rpidData[rPId] && this.rpidData[rPId]["total"] == 2) {
          let index = this.rpidData[rPId]['instance'][0];
          let marker = null ;

          if (this.dataMarkerInstance && this.dataMarkerInstance[index]) {
            if (this.dataMarkerInstance[index].marker1Coordinates && rPId === this.dataMarkerInstance[index].marker1Coordinates.id) {
              marker = this.dataMarkerInstance[index].marker1;
            }
            if (this.dataMarkerInstance[index].marker2Coordinates && rPId === this.dataMarkerInstance[index].marker2Coordinates.id) {
              marker = this.dataMarkerInstance[index].marker2;
            }
          }
          else {
            marker = _marker;
          }

          this.updateMarkerIcon(marker, markerColor.sourceDestinationClick, ++zIndex);
        }
      }

    }

  }
  catch (error) {
    console.log("Error : ", error)
  }

  return marker;
}

// Close the info window 
dashBoardMap.prototype.infoWindowClosed = function (_infoWindowMarker1) {
  _infoWindowMarker1 && _infoWindowMarker1.close();
}

/*
//addListener on marker
*/
dashBoardMap.prototype.addMarkerListener = function () {
  var self = this;
  let length = this.dataMarkerInstance.length;
  const activeMarkerId = self.getClickedMarkerDetails() ? self.getClickedMarkerDetails().activeMarkerId : "";

  for (let index = 0; index < length; index++) {
    let dataMarkerInstance = this.dataMarkerInstance[index];
    let marker1 = dataMarkerInstance.marker1;
    let marker2 = dataMarkerInstance.marker2;
    let marker1Coordinates = dataMarkerInstance.marker1Coordinates;
    let marker2Coordinates = dataMarkerInstance.marker2Coordinates;
    let id = null;
    let idOpposite = null;
    let incoming = 0;
    let outcoming = 0;
    let total = incoming + outcoming;
    let liveTime = 0;
    let liveTimeOpposite = 0;
    let receiverName = "";
    let receiverNameOpposite = "";
    let receiverAccount = "";
    let receiverGroupName = "";
    let incomingDetails = "";
    let outcomingDetails = "";
    let receiverNameDetails = "";
    let receiverAccountDetails = "";
    let receiverGroupNameDetails = "";
    let infoWindowMarker1 = null;
    let infoWindowMarker2 = null;

    let isSame = 0;//Is source and destination same
    //console.log("index=" , index);
    if (marker1 && marker2 && marker1Coordinates.peerID == marker2Coordinates.livePeerID) {
      isSame = 1;
    }

    // create marker for destination
    if (marker1) {
      //console.log("rpidData -- marker1  .. 1");
      let latLngTotal = marker1Coordinates.lat + "" + marker1Coordinates.lng;
      let rpid = marker1Coordinates.peerID;

      //
      if(activeMarkerId === rpid ){
        dataMarkerInstance.activeMarkerId = rpid;
        dataMarkerInstance.activeInstance = "marker1";
        self.clickedMarkerDetails = dataMarkerInstance
      }

      //destination marker click event 
      google.maps.event.addListener(marker1, 'click', function (e) {
        //console.log("marker1 click event --> self.latLngData", self.latLngData);
        //console.log("marker1 click event --> self.latLngData.length --> ", self.latLngData.length);

        // reset the zindex for line and marker
        zIndex++;

        self.updateReceiverColorClickOnDestination(dataMarkerInstance, index);
        self.updateCurveColorList(self.rpidData[rpid]["totalInOutLine"], rpid);//this line is depend upon above line due to inc of ['click']

        //do not delete below line
        latLngTotal = marker1Coordinates.lat + "" + marker1Coordinates.lng;
        rpid = marker1Coordinates.peerID;

        if (!(infoWindowMarker1 && infoWindowMarker1.getMap())) {
          //Close any previous popup and then popup for new last click one 
          self.previousInfoWindowClosed();

          id = marker1Coordinates.id;
          idOpposite = marker2Coordinates ? marker2Coordinates.id : "";
          incoming = self.infoData["incoming"][id];
          
          outcoming = self.infoData["outcoming"][id];
          total = incoming + outcoming;


          incomingDetails = "";
          outcomingDetails = "";
          receiverNameDetails = "";
          receiverAccountDetails = "";
          receiverGroupNameDetails = "";

          if (self.infoData["incomingDetails"][id]) {
            incomingDetails = '<br> ' + self.infoData["incomingDetails"][id];
          }
          if (self.infoData["outcomingDetails"][id]) {
            outcomingDetails = '<br> ' + self.infoData["outcomingDetails"][id];
          }
          if (self.infoData["receiverNameDetails"][id]) {
            receiverNameDetails = self.infoData["receiverNameDetails"][id];
          }
          if (self.infoData["receiverAccountDetails"][id]) {
            receiverAccountDetails = self.infoData["receiverAccountDetails"][id];
          }
          if (self.infoData["receiverGroupNameDetails"][id]) {
            receiverGroupNameDetails = self.infoData["receiverGroupNameDetails"][id];
          }
          

          self.setInfoWindowContent(id, incoming, outcoming, total, incomingDetails, outcomingDetails, receiverNameDetails, receiverAccountDetails, receiverGroupNameDetails, maxWidthPopup);
          
          /*infoWindowMarker1 = new google.maps.InfoWindow({
            content: "<b>Receiver PID : </b>" + id + "<br><b>Receiver Name : </b>" + receiverNameDetails + "<br><b>Receiver Account : </b>" + receiverAccountDetails + "<br><b>Receiver Group Name : </b>" + receiverGroupNameDetails + "<br><b>Total Live Link Id : </b>" + total + "<br><b>Incoming : </b>" + incoming + incomingDetails + "<br><b>Outgoing : </b>" + outcoming + outcomingDetails,
            maxWidth: maxWidthPopup
          });*/
          infoWindowMarker1 = new google.maps.InfoWindow(self.getInfoWindowData(infoWindowContent));

          infoWindowMarker1.open(self.map, marker1);
          self.infoWindowMarker = infoWindowMarker1 ;

          dataMarkerInstance.activeMarkerId = rpid;
          dataMarkerInstance.activeInstance = "marker1";
          dataMarkerInstance.activePopupInstance = infoWindowMarker1
          self.clickedMarkerDetails = dataMarkerInstance

          google.maps.event.addListener(infoWindowMarker1, 'closeclick', (function (e) {
            setTimeout(function () {
              //comments for testing
              //google.maps.event.trigger(self.dataMarkerInstance[index].marker1, 'click');
              self.infoWindowClosed(infoWindowMarker1);
            }, 1);
          }));

        }
        else {
          //infoWindowMarker1 && infoWindowMarker1.close();
          self.infoWindowClosed(infoWindowMarker1);
        }

        //console.log("rpid --> ", rpid);

        //self.overLappingMarkerPopUp(self.latLngData[latLngTotal]);
        //self.overLappingMarkerPopUp(rpid, [self.rpidData[rpid]]);
        //console.log(self.latLngData);
        //console.log(latLngTotal);
        self.rangeData(marker1Coordinates.lat, marker1Coordinates.lng) ;
        self.overLappingMarkerPopUp(self.latLngData[latLngTotal], self.rpidData, self.dataMarkerInstance);
      });//destination marker click event 

      //console.log("rpid -- marker1  .. 5");
    }//end if for marker1

    //create marker for source 
    if (marker2) {
      let latLngTotal = marker2Coordinates.lat + "" + marker2Coordinates.lng;
      let rpid = marker2Coordinates.livePeerID;

      //
      if(activeMarkerId === rpid ){
        dataMarkerInstance.activeMarkerId = rpid;
        dataMarkerInstance.activeInstance = "marker2";
        self.clickedMarkerDetails = dataMarkerInstance
      }     

      //source marker click event 
      google.maps.event.addListener(marker2, 'click', function (e) {

        zIndex++;

        //self.updateReceiverColorClickOnSource(dataMarkerInstance, position);
        self.updateReceiverColorClickOnSource(dataMarkerInstance, index);
        self.updateCurveColorList(self.rpidData[rpid]["totalInOutLine"], rpid); //this line is depend upon above line due to inc of ['click']
        //self.updateReceiverColorClickOnSource(marker1, marker2, rpid, position, isSame);

        latLngTotal = marker2Coordinates.lat + "" + marker2Coordinates.lng;
        rpid = marker2Coordinates.livePeerID;


        if (!(infoWindowMarker2 && infoWindowMarker2.getMap())) {
          //Close any previous popup and then popup for new last click one 
          self.previousInfoWindowClosed();

          id = marker2Coordinates.id;
          idOpposite = marker1Coordinates ? marker1Coordinates.id : "";
          incoming = self.infoData["incoming"][id];
          outcoming = self.infoData["outcoming"][id];
          total = incoming + outcoming;

          incomingDetails = "";
          outcomingDetails = "";
          receiverNameDetails = "";
          receiverAccountDetails = "";
          receiverGroupNameDetails = "";

          if (self.infoData["incomingDetails"][id]) {
            incomingDetails = '<br> ' + self.infoData["incomingDetails"][id];
          }
          if (self.infoData["outcomingDetails"][id]) {
            outcomingDetails = '<br> ' + self.infoData["outcomingDetails"][id];
          }
          if (self.infoData["receiverNameDetails"][id]) {
            receiverNameDetails = self.infoData["receiverNameDetails"][id];
          }
          if (self.infoData["receiverAccountDetails"][id]) {
            receiverAccountDetails = self.infoData["receiverAccountDetails"][id];
          }
          if (self.infoData["receiverGroupNameDetails"][id]) {
            receiverGroupNameDetails = self.infoData["receiverGroupNameDetails"][id];
          }

          self.setInfoWindowContent(id, incoming, outcoming, total, incomingDetails, outcomingDetails, receiverNameDetails, receiverAccountDetails, receiverGroupNameDetails, maxWidthPopup);
          /*infoWindowMarker2 = new google.maps.InfoWindow({
            content: "<b>Receiver PID : </b>" + id + "<br><b>Receiver Name : </b>" + receiverNameDetails + "<br><b>Receiver Account : </b>" + receiverAccountDetails + "<br><b>Receiver Group Name : </b>" + receiverGroupNameDetails + "<br><b>Total Live Link Id : </b>" + total + "<br><b>Incoming : </b>" + incoming + incomingDetails + "<br><b>Outgoing : </b>" + outcoming + outcomingDetails,
            maxWidth: maxWidthPopup
          });*/
          infoWindowMarker2 = new google.maps.InfoWindow(self.getInfoWindowData(infoWindowContent));
          infoWindowMarker2.open(self.map, marker2);
          self.infoWindowMarker = infoWindowMarker2;

          dataMarkerInstance.activeMarkerId = rpid;
          dataMarkerInstance.activeInstance = "marker2";
          dataMarkerInstance.activePopupInstance = infoWindowMarker2
          self.clickedMarkerDetails = dataMarkerInstance

          google.maps.event.addListener(infoWindowMarker2, 'closeclick', (function (e) {
            setTimeout(function () {
              //comments for testing
              //google.maps.event.trigger(self.dataMarkerInstance[index].marker2, 'click');
              self.infoWindowClosed(infoWindowMarker2);
            }, 1);
          }));

        }
        else {
          //infoWindowMarker2 && infoWindowMarker2.close();
          self.infoWindowClosed(infoWindowMarker2);
        }

        self.rangeData(marker2Coordinates.lat, marker2Coordinates.lng) ;
        self.overLappingMarkerPopUp(self.latLngData[latLngTotal], self.rpidData, self.dataMarkerInstance);

      });//source marker click event 
    } //end if for marker2


  }// End for loop

  //console.log(this.dataMarkerInstance[0].marker1.icon == markerColor.sourceDestinationClick);
  //console.log(this.dataMarkerInstance[1].marker2.icon== markerColor.sourceDestinationClick);

}

/*
// Set the content of the info window
*/
dashBoardMap.prototype.clearInfoWindowContent = function(){
  // infoWindowContent.id = id;
  // infoWindowContent.incoming = incoming;
  // infoWindowContent.outcoming = outcoming;
  // infoWindowContent.total = total;
  // infoWindowContent.incomingDetails = incomingDetails;
  // infoWindowContent.outcomingDetails = outcomingDetails;
  // infoWindowContent.receiverNameDetails = receiverNameDetails;
  // infoWindowContent.receiverAccountDetails = receiverAccountDetails;
  // infoWindowContent.receiverGroupNameDetails = receiverGroupNameDetails;
  // infoWindowContent.maxWidthPopup = maxWidthPopup;
  infoWindowContent = {}
}


/*
// Set the content of the info window
*/
dashBoardMap.prototype.setInfoWindowContent = function(_id, _incoming, _outcoming, _total, _incomingDetails, _outcomingDetails, _receiverNameDetails, _receiverAccountDetails, _receiverGroupNameDetails, _maxWidthPopup  ){
  infoWindowContent.id = _id;
  infoWindowContent.incoming = _incoming;
  infoWindowContent.outcoming = _outcoming;
  infoWindowContent.total = _total;
  infoWindowContent.incomingDetails = _incomingDetails;
  infoWindowContent.outcomingDetails = _outcomingDetails;
  infoWindowContent.receiverNameDetails = _receiverNameDetails;
  infoWindowContent.receiverAccountDetails = _receiverAccountDetails;
  infoWindowContent.receiverGroupNameDetails = _receiverGroupNameDetails;
  infoWindowContent.maxWidthPopup = _maxWidthPopup;
}

/*
// get the data of the info window
*/
dashBoardMap.prototype.getInfoWindowContent = function(){
  return infoWindowContent;
}

/*
// get the content of the info window
*/
dashBoardMap.prototype.getInfoWindowData = function(_infoWindowContent){
  const id = _infoWindowContent.id;
  const receiverNameDetails = _infoWindowContent.receiverNameDetails;
  const receiverAccountDetails = _infoWindowContent.receiverAccountDetails;
  const receiverGroupNameDetails = _infoWindowContent.receiverGroupNameDetails;
  const total = _infoWindowContent.total;
  const incoming = _infoWindowContent.incoming;
  const incomingDetails = _infoWindowContent.incomingDetails;
  const outcoming = _infoWindowContent.outcoming;
  const outcomingDetails = _infoWindowContent.outcomingDetails;
  const maxWidthPopup = _infoWindowContent.maxWidthPopup;

  return {
    content: "<b>Receiver PID : </b>" + id + "<br><b>Receiver Name : </b>" + receiverNameDetails + "<br><b>Receiver Account : </b>" + receiverAccountDetails + "<br><b>Receiver Group Name : </b>" + receiverGroupNameDetails + "<br><b>Total Live Link Id : </b>" + total + "<br><b>Incoming : </b>" + incoming + incomingDetails + "<br><b>Outgoing : </b>" + outcoming + outcomingDetails,
    maxWidth: maxWidthPopup
  }
}

/*
// update Receiver Color Click On Destination
*/
dashBoardMap.prototype.updateReceiverColorClickOnDestination = function (_dataMarkerInstance, _index) {
  //alert("updateReceiverColorClickOnDestination");
  //console.log("_dataMarkerInstance ---> ", _dataMarkerInstance );
  let marker1 = _dataMarkerInstance.marker1 ? _dataMarkerInstance.marker1 : null
  let marker2 = _dataMarkerInstance.marker2 ? _dataMarkerInstance.marker2 : null;
  let marker1Coordinates = _dataMarkerInstance.marker1Coordinates;
  let marker2Coordinates = _dataMarkerInstance.marker2Coordinates;
  let peerID = _dataMarkerInstance.marker1Coordinates.peerID;
  let livePeerID = _dataMarkerInstance.marker2Coordinates ? _dataMarkerInstance.marker2Coordinates.livePeerID : null;

  let marker2ToggleImage = null;
  let marker1ToggleImage = null;
  let clickedMarkerId = peerID;
  let isSame = 0;

  this.rpidData[peerID]['click'] = this.rpidData[peerID]['click'] + 1;

  if (marker1 && marker2 && marker1Coordinates.peerID != marker2Coordinates.livePeerID) {
    let m1LagLng = marker1Coordinates.lat + marker1Coordinates.lng ;
    let m2LagLng = marker2Coordinates.lat + marker2Coordinates.lng ;
    if(m1LagLng === m2LagLng){
      isSame = 1;
    }
  }


  //Update distination marker icon
  //Check it is single marker or overlapping marker
  let totalPeerID = this.rpidData[peerID]['instance'].length;
  //Check for simple destination marker or unique destination marker
  //console.log("totalPeerID --> ", totalPeerID);

  if (totalPeerID > 1) {
    //unique marker
    // 0 position should be the unique marker
    let indexDataMarkerInstance = this.rpidData[peerID]['instance'][0];

    if (peerID === this.dataMarkerInstance[indexDataMarkerInstance].marker1Coordinates.peerID) {
      marker1 = this.dataMarkerInstance[indexDataMarkerInstance].marker1;
    }
    else if (peerID === this.dataMarkerInstance[indexDataMarkerInstance].marker2Coordinates.livePeerID) {
      marker1 = this.dataMarkerInstance[indexDataMarkerInstance].marker2;
    }

    marker1ToggleImage = markerColor.sourceDestinationClick;
  }
  else {
    //single marker 
    if (livePeerID) {
      if (this.rpidData[peerID]['click'] % 2 == 1) {
        marker1ToggleImage = markerColor.destinationClick;
      }
      else {
        marker1ToggleImage = markerColor.destination;
      }
    }
  }

  //console.log(" sourceDestinationClick = ", marker1ToggleImage == markerColor.sourceDestinationClick);
  //It may be simple destination marker or unique destination marker
  if (marker1ToggleImage) {
    this.updateMarkerIcon(marker1, marker1ToggleImage, ++zIndex);
  }

  // update other marker related with this click marker 
  //update source either one source or one destination 
  //or 
  //update source/destination i.e. overlapping marker
  //alert("totalPeerID -->... "+ totalPeerID)
  if (livePeerID == null) {
    return;
  }

  if (totalPeerID > 1) {
    // It is source marker so we use totalPeerID
    for (let index = 0; index < totalPeerID; index++) {
      //find the other side (i.e. it may be source or destination) marker for change its icon
      let indexDataMarkerInstance = this.rpidData[peerID]['instance'][index];

      //console.log("index --> ", index, ",  this.dataMarkerInstance[indexDataMarkerInstance].marker1Coordinates.id --> ", this.dataMarkerInstance[indexDataMarkerInstance].marker1Coordinates.id);
      //console.log("index --> ", index, ",  this.dataMarkerInstance[indexDataMarkerInstance].marker2Coordinates.id --> ", this.dataMarkerInstance[indexDataMarkerInstance].marker2Coordinates.id);

      // update color if other side marker is diferent from clicked marker 
      if (this.dataMarkerInstance[indexDataMarkerInstance].marker1Coordinates.id !== this.dataMarkerInstance[indexDataMarkerInstance].marker2Coordinates.id) {
        //console.log("this.rpidData[livePeerID]['instance'][index] ---> ", this.rpidData[livePeerID]['instance'][index]);
        let marker = this.dataMarkerInstance[indexDataMarkerInstance].marker2;// set by default 
        let markerId = this.dataMarkerInstance[indexDataMarkerInstance].marker2Coordinates.livePeerID;
        let markerType;
        markerType = coordinate.source;
        let clickedMarkerType = "";
        //set the clickedmarker details
        if (clickedMarkerId == this.dataMarkerInstance[indexDataMarkerInstance].marker1Coordinates.peerID) {
          clickedMarkerType = coordinate.destination;
        } else if (clickedMarkerId == this.dataMarkerInstance[indexDataMarkerInstance].marker2Coordinates.livePeerID) {
          clickedMarkerType = coordinate.source;
        }
        if (clickedMarkerId !== this.dataMarkerInstance[indexDataMarkerInstance].marker1Coordinates.peerID) {
          marker = this.dataMarkerInstance[indexDataMarkerInstance].marker1;
          markerId = this.dataMarkerInstance[indexDataMarkerInstance].marker1Coordinates.peerID;
          markerType = coordinate.destination;
        }

        // check marker is unique or simple by using count
        let totalMarkerID = this.rpidData[markerId]['instance'].length;

        if (totalMarkerID > 1) {
          const indexMarker = this.rpidData[markerId]['instance'][0];
          marker = this.dataMarkerInstance[indexMarker].marker2;
          markerType = coordinate.source;

          if (markerId === this.dataMarkerInstance[indexMarker].marker1Coordinates.peerID) {
            marker = this.dataMarkerInstance[indexMarker].marker1;
            markerType = coordinate.destination;
          }
          // if (this.rpidData[peerID]['click'] % 2 == 1) {
          //   if (markerType == coordinate.source) {
          //     marker2ToggleImage = markerColor.sourceClick;
          //   }
          //   else {
          //     marker2ToggleImage = markerColor.destinationClick;
          //   }
          // }
          // else {
          //   if (markerType == coordinate.source) {
          //     marker2ToggleImage = markerColor.source;
          //   }
          //   else {
          //     marker2ToggleImage = markerColor.destination;
          //   }
          // }
          //console.log(clickedMarkerType == coordinate.source);
          //console.log("this.rpidData[peerID]['click'] --> ", this.rpidData[peerID]['click']);
          if (clickedMarkerType == coordinate.source) {
            if (this.rpidData[peerID]['click'] % 2 == 1) {
              marker2ToggleImage = markerColor.destinationClick;
            }
            else if (this.rpidData[peerID]['click'] % 2 == 0) {
              marker2ToggleImage = markerColor.destination;
            }
          }
          if (clickedMarkerType == coordinate.destination) {
            if (this.rpidData[peerID]['click'] % 2 == 1) {
              marker2ToggleImage = markerColor.sourceClick;
            }
            else if (this.rpidData[peerID]['click'] % 2 == 0) {
              marker2ToggleImage = markerColor.source;
            }
          }

        }
        else {
          if (this.rpidData[peerID]['click'] % 2 == 1) {
            if (markerType == coordinate.source) {
              marker2ToggleImage = markerColor.sourceClick;
            }
            else {
              marker2ToggleImage = markerColor.destinationClick;
            }
          }
          else {
            if (markerType == coordinate.source) {
              marker2ToggleImage = markerColor.source;
            }
            else {
              marker2ToggleImage = markerColor.destination;
            }
          }
        }

        this.updateMarkerIcon(marker, marker2ToggleImage, ++zIndex);
      }

    }// end for loop

  }
  else {
    //set empty
    marker2ToggleImage = "";
    //check this marker is simple or unique 
    let totalMarkerId = this.rpidData[livePeerID]['instance'].length;
    //alert("totalMarkerId = " + totalMarkerId)
    let markerType;

    if (totalMarkerId > 1) {
      //find the unique marker instane  
      const indexMarker = this.rpidData[livePeerID]['instance'][0];
      let marker = this.dataMarkerInstance[indexMarker].marker2;
      markerType = coordinate.source;
      if (livePeerID === this.dataMarkerInstance[indexMarker].marker1Coordinates.peerID) {
        marker = this.dataMarkerInstance[indexMarker].marker1;
        markerType = coordinate.destination;
      }
      marker2 = marker;
      //console.log("this.rpidData[peerID]['click'] --> ", this.rpidData[peerID]['click']);
      if (this.rpidData[peerID]['click'] % 2 == 1) {
        marker2ToggleImage = markerColor.sourceClick;
        // if (markerType == coordinate.source) {
        //   marker2ToggleImage = markerColor.sourceClick;
        // }
        // else {
        //   marker2ToggleImage = markerColor.destinationClick;
        // }        
      }
      else {
        marker2ToggleImage = markerColor.source;
        // if (markerType == coordinate.source) {
        //   marker2ToggleImage = markerColor.source;
        // }
        // else {
        //   marker2ToggleImage = markerColor.destination;
        // }        
      }

    }
    else {
      //simple marker
      if (this.rpidData[peerID]['click'] % 2 == 1) {
        marker2ToggleImage = markerColor.sourceClick;
      }
      else {
        marker2ToggleImage = markerColor.source;
      }
    }

    //It may be simple destination marker or unique destination marker
    this.updateMarkerIcon(marker2, marker2ToggleImage, isSame ? zIndex : ++zIndex);

  }

}


//please use updateReceiverIconColorClickOnMarker instead of updateReceiverColorClickOnSource
//dashBoardMap.prototype.updateReceiverIconColorClickOnMarker = function (_index) {
dashBoardMap.prototype.updateReceiverColorClickOnSource = function (_dataMarkerInstance, _index) {
  //alert("updateReceiverColorClickOnSource");
  //console.log("this.dataMarkerInstance ---> ", this.dataMarkerInstance);
  let marker1 = _dataMarkerInstance.marker1;
  let marker2 = _dataMarkerInstance.marker2;
  let marker1Coordinates = _dataMarkerInstance.marker1Coordinates;
  let marker2Coordinates = _dataMarkerInstance.marker2Coordinates;
  let livePeerID = _dataMarkerInstance.marker2Coordinates.livePeerID;
  let peerID = _dataMarkerInstance.marker1Coordinates.peerID;
  let marker2ToggleImage;
  let marker1ToggleImage;
  let isSame = 0;
  // clickedMarkerId is the id which is clicked bu user for source marker
  let clickedMarkerId = livePeerID;
  
  if (marker1 && marker2 && marker1Coordinates.peerID != marker2Coordinates.livePeerID) {
    let m1LagLng = marker1Coordinates.lat + marker1Coordinates.lng ;
    let m2LagLng = marker2Coordinates.lat + marker2Coordinates.lng ;
    if(m1LagLng === m2LagLng){
      isSame = 1;
    }    
  }

  //console.log("livePeerID --> ", livePeerID);
  this.rpidData[livePeerID]['click'] = this.rpidData[livePeerID]['click'] + 1;

  //Update source marker icon
  //Check it is single marker or overlapping marker
  //It will contains the ref index of the dataMarkerInstance for the livePeerID 
  let totalLivePeerID = this.rpidData[livePeerID]['instance'].length;
  //console.log("this.rpidData[livePeerID]['instance'] -->  ", this.rpidData[livePeerID]['instance']);
  //console.log("clickedMarkerId --> ", clickedMarkerId);
  //Check for simple source marker or unique source marker
  //console.log("totalLivePeerID --> ", totalLivePeerID)
  if (totalLivePeerID > 1) {
    //unique marker
    // 0 position should be the unique marker
    let indexDataMarkerInstance = this.rpidData[livePeerID]['instance'][0];
    if (livePeerID === this.dataMarkerInstance[indexDataMarkerInstance].marker2Coordinates.peerID) {
      marker2 = this.dataMarkerInstance[indexDataMarkerInstance].marker2;
    }
    else if (livePeerID === this.dataMarkerInstance[indexDataMarkerInstance].marker1Coordinates.peerID) {
      marker2 = this.dataMarkerInstance[indexDataMarkerInstance].marker1;
    }
    // else 
    // if(livePeerID ===  this.dataMarkerInstance[indexDataMarkerInstance].marker2Coordinates.livePeerID ){
    //   marker = this.dataMarkerInstance[indexDataMarkerInstance].marker2;
    //   console.log("marker2 --> ", indexDataMarkerInstance);
    // }
    //marker2 = marker; 

    // if(marker.icon === markerColor.source || marker.icon === markerColor.sourceClick ){
    //   marker2ToggleImage = this.toggleIcon(marker, markerColor.source, markerColor.sourceClick);
    // }
    // else{
    //   marker2ToggleImage = markerColor.sourceClick;
    // }
    marker2ToggleImage = markerColor.sourceDestinationClick;
  }
  else {
    //simple marker 
    if (this.rpidData[livePeerID]['click'] % 2 == 1) {
      marker2ToggleImage = markerColor.sourceClick;
    }
    else {
      marker2ToggleImage = markerColor.source;
    }

    //marker2ToggleImage = this.toggleIcon(marker2, markerColor.source, markerColor.sourceClick);
  }

  //It may be simple source marker or unique source marker
  this.updateMarkerIcon(marker2, marker2ToggleImage, ++zIndex);

  //console.log(this.dataMarkerInstance[0].marker1.icon == markerColor.sourceDestinationClick);
  //console.log(this.dataMarkerInstance[1].marker2.icon == markerColor.sourceDestinationClick);



  //update destination either one source or one destination 
  //or 
  //update source/destination i.e. overlapping marker
  //console.log("totalLivePeerID --> ", totalLivePeerID)
  if (totalLivePeerID > 1) {
    // It is source marker so we use totalLivePeerID
    for (let index = 0; index < totalLivePeerID; index++) {
      //console.log("index --> ", index);
      //find the other side (i.e. it may be source or destination) marker for change its icon
      let indexDataMarkerInstance = this.rpidData[livePeerID]['instance'][index];
      //console.log("indexDataMarkerInstance --> ", indexDataMarkerInstance,  ", this.dataMarkerInstance[indexDataMarkerInstance] --> ", this.dataMarkerInstance[indexDataMarkerInstance]);

      if (this.dataMarkerInstance[indexDataMarkerInstance].marker1Coordinates.id !== this.dataMarkerInstance[indexDataMarkerInstance].marker2Coordinates.id) {
        let marker = this.dataMarkerInstance[indexDataMarkerInstance].marker1;
        let markerId = this.dataMarkerInstance[indexDataMarkerInstance].marker1Coordinates.peerID;
        let markerType = coordinate.destination;
        let clickedMarkerType = "";
        //set the clickedmarker details
        if (clickedMarkerId == this.dataMarkerInstance[indexDataMarkerInstance].marker1Coordinates.peerID) {
          clickedMarkerType = coordinate.destination;
        } else if (clickedMarkerId == this.dataMarkerInstance[indexDataMarkerInstance].marker2Coordinates.livePeerID) {
          clickedMarkerType = coordinate.source;
        }

        if (clickedMarkerId !== this.dataMarkerInstance[indexDataMarkerInstance].marker2Coordinates.livePeerID) {
          marker = this.dataMarkerInstance[indexDataMarkerInstance].marker2;
          markerId = this.dataMarkerInstance[indexDataMarkerInstance].marker2Coordinates.livePeerID;
          markerType = coordinate.source;
        }
        // check marker is unique or simple by using count
        let totalMarkerID = this.rpidData[markerId]['instance'].length;
        //console.log("totalMarkerID = ", totalMarkerID);
        if (totalMarkerID > 1) {
          const indexMarker = this.rpidData[markerId]['instance'][0];
          //console.log("this.rpidData[markerId]['instance'] --> ", this.rpidData[markerId]['instance']);
          marker = this.dataMarkerInstance[indexMarker].marker1;
          markerType = coordinate.destination;
          if (markerId === this.dataMarkerInstance[indexMarker].marker2Coordinates.livePeerID) {
            marker = this.dataMarkerInstance[indexMarker].marker2;
            markerType = coordinate.source;
          }
          // if (this.rpidData[livePeerID]['click'] % 2 == 1) {
          //   if (markerType == coordinate.destination) {
          //     marker1ToggleImage = markerColor.destinationClick;
          //   }
          //   else {
          //     marker1ToggleImage = markerColor.sourceClick;
          //   }
          // }
          // else {
          //   if (markerType == coordinate.destination) {
          //     marker1ToggleImage = markerColor.destination;
          //   }
          //   else {
          //     marker1ToggleImage = markerColor.source;
          //   }
          // }

          if (clickedMarkerType == coordinate.source) {
            if (this.rpidData[livePeerID]['click'] % 2 == 1) {
              marker1ToggleImage = markerColor.destinationClick;
            }
            else if (this.rpidData[livePeerID]['click'] % 2 == 0) {
              marker1ToggleImage = markerColor.destination;
            }
          }
          if (clickedMarkerType == coordinate.destination) {
            if (this.rpidData[livePeerID]['click'] % 2 == 1) {
              marker1ToggleImage = markerColor.sourceClick;
            }
            else if (this.rpidData[livePeerID]['click'] % 2 == 0) {
              marker1ToggleImage = markerColor.source;
            }
          }

        }
        else {
          //console.log("else......")
          if (this.rpidData[livePeerID]['click'] % 2 == 1) {
            if (markerType == coordinate.destination) {
              marker1ToggleImage = markerColor.destinationClick;
            }
            else {
              marker1ToggleImage = markerColor.sourceClick;
            }
          }
          else {
            if (markerType == coordinate.destination) {
              marker1ToggleImage = markerColor.destination;
            }
            else {
              marker1ToggleImage = markerColor.source;
            }
          }
        }
        this.updateMarkerIcon(marker, marker1ToggleImage, ++zIndex);
      }

    }// end for loop
  }
  else {
    //set empty
    marker1ToggleImage = "";
    //check this marker is simple or unique 
    let totalMarkerId = this.rpidData[peerID]['instance'].length;
    //alert(totalMarkerId)
    let markerType;
    if (totalMarkerId > 1) {
      //find the unique marker instane  
      const indexMarker = this.rpidData[peerID]['instance'][0];
      let marker = this.dataMarkerInstance[indexMarker].marker1;
      markerType = coordinate.destination;
      if (peerID === this.dataMarkerInstance[indexMarker].marker2Coordinates.livePeerID) {
        marker = this.dataMarkerInstance[indexMarker].marker2;
        markerType = coordinate.source;
      }
      marker1 = marker;

      if (this.rpidData[livePeerID]['click'] % 2 == 1) {
        marker1ToggleImage = markerColor.destinationClick;
      }
      else {
        marker1ToggleImage = markerColor.destination;
      }

      // if (marker2ToggleImage == markerColor.sourceClick) {
      //   marker1ToggleImage = markerColor.destinationClick;
      // }
      // if (marker2ToggleImage == markerColor.source) {
      //   marker1ToggleImage = markerColor.destination;
      // }

    }
    else {
      //simple marker
      if (this.rpidData[livePeerID]['click'] % 2 == 1) {
        marker1ToggleImage = markerColor.destinationClick;
      }
      else {
        marker1ToggleImage = markerColor.destination;
      }
    }

    //It may be simple destination marker or unique destination marker
    //zindex should be increased and marker should topped when lat and lng are different
    this.updateMarkerIcon(marker1, marker1ToggleImage, isSame ? zIndex : ++zIndex); 
    //this.updateMarkerIcon(this.dataMarkerInstance[1].marker2, markerColor.destination, ++zIndex);    
  }



  // if (totalPeerID > 1){
  //   const indexDataMarkerInstance = this.rpidData[peerID]['instance'][0]; 
  //   let marker; 
  //   if(peerID ===  this.dataMarkerInstance[indexDataMarkerInstance].marker1Coordinates.peerID ){
  //     marker = this.dataMarkerInstance[indexDataMarkerInstance].marker1;
  //   }
  //   else if(peerID ===  this.dataMarkerInstance[indexDataMarkerInstance].marker2Coordinates.livePeerID ){
  //     marker = this.dataMarkerInstance[indexDataMarkerInstance].marker2;
  //   }
  //   marker1 = marker;

  //   if(marker2ToggleImage === markerColor.sourceClick){
  //     marker1ToggleImage = markerColor.destinationClick;
  //   }
  //   else if(marker2ToggleImage === markerColor.source){
  //     marker1ToggleImage = markerColor.destination;
  //   }
  //   else if(marker2ToggleImage === markerColor.destination){
  //     marker1ToggleImage = markerColor.destinationClick;
  //   }    
  //   else if(marker2ToggleImage === markerColor.destinationClick){
  //     marker1ToggleImage = markerColor.destination;
  //   }    
  //   else{
  //     alert(999999999)
  //   }
  // }
  // else{
  //   //simple marker 
  //   marker1ToggleImage = this.toggleIcon(marker1, markerColor.destination, markerColor.destinationClick);
  //   tempImage = "";
  // }
  // //It may be simple destination marker or unique destination marker
  // this.updateMarkerIcon(marker1, marker1ToggleImage, ++zIndex);
}


/*
// Icon click at popup 
*/
dashBoardMap.prototype.commonClick = function (_instance) {
  //let self = this;
  //console.log("commonClick --> _instance --> ", _instance);
  //if(self.dataMarkerInstance[_index].marker1) google.maps.event.trigger( self.dataMarkerInstance[_index].marker1, 'click' )
  //console.log(self.dataMarkerInstance[0]);

  //_instance = self.dataMarkerInstance[0].marker2
  if (_instance) {
    google.maps.event.trigger(_instance, 'click');
  }
}


/*
// Icon click at popup 
*/
dashBoardMap.prototype.popupCloseClick = function (_instance) {
  if (_instance) {
    google.maps.event.trigger(_instance, 'closeclick');
  }
}


/*
// Line/Curve between marker and click listener 
*/
dashBoardMap.prototype.polylineAndClickListener = function (_coordinates, _index) {

  var self = this;
  //console.log("_coordinates --> ", _coordinates);
  // create line when both marker available else no need to create line
  // _coordinates[0] is destination and _coordinates[1] is source 
  if (_coordinates && _coordinates.length >= 2) {
    // line from source to destination
    var lineCoordinates = [{
      lat: _coordinates[0].lat,
      lng: _coordinates[0].lng
    },
    {
      lat: _coordinates[1].lat,
      lng: _coordinates[1].lng
    }
    ];

    // closed arrow from source to destination
    var lineSymbol = {
      path: google.maps.SymbolPath.BACKWARD_CLOSED_ARROW
    };
    zIndex++;
    var linePathObj = new google.maps.Polyline({
      path: lineCoordinates,
      geodesic: true,
      strokeColor: curveDefaultColor,
      strokeOpacity: 1.0,
      strokeWeight: strokeWeight,
      icons: [{
        icon: lineSymbol,
        offset: '0%'
      }],
      zIndex: zIndex
    });

    linePathObj.setMap(this.map);
    this.linePath.push(linePathObj);

    //we need to add the index position in the array. 
    const currentIndex = this.linePath.length - 1;
    if (currentIndex >= 0) {
      this.rpidData[_coordinates[0].id]['totalInOutLine'].push(currentIndex);
      this.rpidData[_coordinates[1].id]['totalInOutLine'].push(currentIndex);
    }

    linePathObj.addListener('click', function (e) {
      let marker1 = self.dataMarkerInstance[_index].marker1;
      let marker2 = self.dataMarkerInstance[_index].marker2;
      zIndex++;
      self.dataMarkerInstance[_index]['clickLine'] = self.dataMarkerInstance[_index]['clickLine'] + 1;

      let colorMarker1 = "";
      let colorMarker2 = "";
      let colorDefaultClick = "";
      //console.log("self.dataMarkerInstance[_index]['clickLine'] % 2 --> ", self.dataMarkerInstance[_index]['clickLine'] % 2);
      if (self.dataMarkerInstance[_index]['clickLine'] % 2 == 1) {
        colorMarker1 = markerColor.destinationClick;
        colorMarker2 = markerColor.sourceClick;
        colorDefaultClick = curveClickColor;
      }
      else {
        colorMarker1 = markerColor.destination;
        colorMarker2 = markerColor.source;
        colorDefaultClick = curveDefaultColor;
      }

      //linePathObj.setOptions({ strokeColor: self.toggleColor(linePathObj, curveDefaultColor, curveClickColor), zIndex: zIndex });
      linePathObj.setOptions({ strokeColor: colorDefaultClick, zIndex: zIndex });

      let peerID = self.dataMarkerInstance[_index].marker1Coordinates.peerID;
      let livePeerID = self.dataMarkerInstance[_index].marker2Coordinates.livePeerID;
      //console.log("peerID -----------------", self.rpidData[peerID]['instance'].length);
      //console.log("livePeerID -----------------", self.rpidData[livePeerID]['instance'].length);
      if (self.rpidData[peerID]['instance'].length > 1) {
        let indexDataMarkerInstance = self.rpidData[peerID]['instance'][0];
        if (self.dataMarkerInstance[_index].marker1Coordinates.peerID == self.dataMarkerInstance[indexDataMarkerInstance].marker2Coordinates.livePeerID) {
          marker1 = self.dataMarkerInstance[indexDataMarkerInstance].marker2;
        }
        if (self.dataMarkerInstance[_index].marker1Coordinates.peerID == self.dataMarkerInstance[indexDataMarkerInstance].marker1Coordinates.peerID) {
          marker1 = self.dataMarkerInstance[indexDataMarkerInstance].marker1;
        }
      }


      //self.updateMarkerIcon(self.dataMarkerInstance[_index].marker1, self.toggleIcon(self.dataMarkerInstance[_index].marker1, markerColor.destination, markerColor.destinationClick), zIndex);
      self.updateMarkerIcon(marker1, colorMarker1, zIndex);

      zIndex++;

      if (self.rpidData[livePeerID]['instance'].length > 1) {
        let indexDataMarkerInstance = self.rpidData[livePeerID]['instance'][0];
        if (self.dataMarkerInstance[_index].marker2Coordinates.livePeerID == self.dataMarkerInstance[indexDataMarkerInstance].marker2Coordinates.livePeerID) {
          marker2 = self.dataMarkerInstance[indexDataMarkerInstance].marker2;
        }
        if (self.dataMarkerInstance[_index].marker2Coordinates.livePeerID == self.dataMarkerInstance[indexDataMarkerInstance].marker1Coordinates.peerID) {
          marker2 = self.dataMarkerInstance[indexDataMarkerInstance].marker1;
        }
      }
      //self.updateMarkerIcon(self.dataMarkerInstance[_index].marker2, self.toggleIcon(self.dataMarkerInstance[_index].marker2, markerColor.source, markerColor.sourceClick), zIndex);
      self.updateMarkerIcon(marker2, colorMarker2, zIndex);
      
      //hide icon for ovverlapping and show/hide logs
      //self.parentDisableIcon();
    });
  } else {
    this.linePath.push(null);
  }

  }

/*
// Calculate populate data 
*/
dashBoardMap.prototype.popupData = function (_data) {

  var incoming = _data.peerID;
  var outcoming = _data.livePeerID;
  var liveTime = _data.liveTime;

  if (this.infoData["liveTime"][incoming]) {
    this.infoData["liveTime"][incoming] = this.infoData["liveTime"][incoming] + liveTime
  } else {
    this.infoData["liveTime"][incoming] = liveTime
  }

  if (this.infoData["liveTime"][outcoming]) {
    this.infoData["liveTime"][outcoming] = this.infoData["liveTime"][outcoming] + liveTime
  } else {
    this.infoData["liveTime"][outcoming] = liveTime
  }

  if (this.infoData["incoming"][incoming]) {
    this.infoData["incoming"][incoming] = this.infoData["incoming"][incoming] + 1;
    this.infoData["incomingDetails"][incoming] = this.infoData["incomingDetails"][incoming] + ' <br>"' + _data.livePeerReceiverName + '" (' + _data.livePeerID + ') ' + this.msToHMS(_data.liveTime);
  } else {
    this.infoData["incoming"][incoming] = 1;
    this.infoData["incomingDetails"][incoming] = ' "' + _data.livePeerReceiverName + '" (' + _data.livePeerID + ') ' + this.msToHMS(_data.liveTime); //"incomingDetails 1 ";
  }

  if (_data.livePeerReceiverName) {
    // if (this.infoData["receiverNameDetails"][outcoming]) {
    //   this.infoData["receiverNameDetails"][outcoming] = this.infoData["receiverNameDetails"][outcoming] + ", " + _data.livePeerReceiverName;
    // }
    // else {
    //   this.infoData["receiverNameDetails"][outcoming] = _data.livePeerReceiverName;
    // }
    //rpid have unique name  
    if (!this.infoData["receiverNameDetails"][outcoming]) {
      this.infoData["receiverNameDetails"][outcoming] = _data.livePeerReceiverName;
    }
  }

  if (_data.livePeerReceiverAccount) {
    // if (this.infoData["receiverAccountDetails"][outcoming]) {
    //   this.infoData["receiverAccountDetails"][outcoming] = this.infoData["receiverAccountDetails"][outcoming] + ", " + _data.livePeerReceiverAccount;
    // }
    // else {
    //   this.infoData["receiverAccountDetails"][outcoming] = _data.livePeerReceiverAccount;
    // }
    //rpid have unique account 
    if (!this.infoData["receiverAccountDetails"][outcoming]) {
      this.infoData["receiverAccountDetails"][outcoming] = _data.livePeerReceiverAccount;
    }
  }

  if (_data.livePeerReceiverGroupName) {
    // if (this.infoData["receiverGroupNameDetails"][outcoming]) {
    //   this.infoData["receiverGroupNameDetails"][outcoming] = this.infoData["receiverGroupNameDetails"][outcoming] + ", " + _data.livePeerReceiverGroupName;
    // }
    // else {
    //   this.infoData["receiverGroupNameDetails"][outcoming] = _data.livePeerReceiverGroupName;
    // }
    //rpid have unique groupname 
    if (!this.infoData["receiverGroupNameDetails"][outcoming]) {
      this.infoData["receiverGroupNameDetails"][outcoming] = _data.livePeerReceiverGroupName;
    }
  }

  if (!this.infoData["outcoming"][incoming]) {
    this.infoData["outcoming"][incoming] = 0;
    this.infoData["outcomingDetails"][incoming] = "";
  }

  if (this.infoData["outcoming"][outcoming]) {
    this.infoData["outcoming"][outcoming] = this.infoData["outcoming"][outcoming] + 1;
    this.infoData["outcomingDetails"][outcoming] = this.infoData["outcomingDetails"][outcoming] + ' <br>"' + _data.peerReceiverName + '" (' + _data.peerID + ') ' + this.msToHMS(_data.liveTime);
  } else {
    this.infoData["outcoming"][outcoming] = 1;
    this.infoData["outcomingDetails"][outcoming] = ' "' + _data.peerReceiverName + '" (' + _data.peerID + ') ' + this.msToHMS(_data.liveTime);//"outcomingDetails 1" 
  }

  if (!this.infoData["incoming"][outcoming]) {
    this.infoData["incoming"][outcoming] = 0;
    this.infoData["incomingDetails"][outcoming] = "";
  }

  if (_data.peerReceiverName) {
    // if (this.infoData["receiverNameDetails"][incoming]) {
    //   this.infoData["receiverNameDetails"][incoming] = this.infoData["receiverNameDetails"][incoming] + ", " + _data.peerReceiverName;
    // }
    // else {
    //   this.infoData["receiverNameDetails"][incoming] = _data.peerReceiverName;
    // }
    //rpid have unique name 
    if (!this.infoData["receiverNameDetails"][incoming]) {
      this.infoData["receiverNameDetails"][incoming] = _data.peerReceiverName;
    }
  }

  if (_data.peerReceiverAccount) {
    // if (this.infoData["receiverAccountDetails"][incoming]) {
    //   this.infoData["receiverAccountDetails"][incoming] = this.infoData["receiverAccountDetails"][incoming] + ", " + _data.peerReceiverAccount;
    // }
    // else {
    //   this.infoData["receiverAccountDetails"][incoming] = _data.peerReceiverAccount;
    // }
    //rpid have unique account 
    if (!this.infoData["receiverAccountDetails"][incoming]) {
      this.infoData["receiverAccountDetails"][incoming] = _data.peerReceiverAccount;
    }
  }

  if (_data.peerReceiverGroupName) {
    // if (this.infoData["receiverGroupNameDetails"][incoming]) {
    //   this.infoData["receiverGroupNameDetails"][incoming] = this.infoData["receiverGroupNameDetails"][incoming] + ", " + _data.peerReceiverGroupName;
    // }
    // else {
    //   this.infoData["receiverGroupNameDetails"][incoming] = _data.peerReceiverGroupName;
    // }
    //rpid have unique groupname 
    if (!this.infoData["receiverGroupNameDetails"][incoming]) {
      this.infoData["receiverGroupNameDetails"][incoming] = _data.peerReceiverGroupName;
    }
  }

  // console.log("this.infoData['incoming']--->", this.infoData["incoming"]);
  // console.log("this.infoData['outcoming']--->", this.infoData["outcoming"]);
  // console.log("this.infoData['receiverNameDetails']--->", this.infoData["receiverNameDetails"]);
  // console.log("this.infoData['receiverAccountDetails']--->", this.infoData["receiverAccountDetails"]);
  // console.log("this.infoData['receiverGroupNameDetails']--->", this.infoData["receiverGroupNameDetails"]);
}

/*
// Toggle the color for curve/line
*/
dashBoardMap.prototype.toggleColor = function (_linePath, _defaultColor, _clickColor) {
  let color = null;
  if (_linePath) {
    color = _linePath.strokeColor == _defaultColor ? _clickColor : _defaultColor;
  }
  return color;
}


// Toggle the line/curve color
dashBoardMap.prototype.updateCurveColor = function (_linePath, _zIndex, _rpid) {
  if (_linePath) {
    //const color = this.toggleColor(_linePath, curveDefaultColor, curveClickColor);
    let color;

    if (this.rpidData[_rpid]['click'] % 2 == 1) {
      color = curveClickColor;
    }
    else {
      color = curveDefaultColor;
    }

    _linePath.setOptions({ strokeColor: color, zIndex: _zIndex });
  }
}

// Toggle list of line/curve color
dashBoardMap.prototype.updateCurveColorList = function (_list, _rpid) {
  //console.log("linePath --> ", this.linePath);
  const total = _list.length;
  for (let index = 0; index < total; index++) {
    this.updateCurveColor(this.linePath[_list[index]], ++zIndex, _rpid);
  }
  //this.updateCurveColor(this.linePath[0], ++zIndex);
}

/*
//Toggle the icon for marker
*/
dashBoardMap.prototype.toggleIcon = function (_marker, _defaultIcon, _clickIcon) {
  let icon = null;
  if (_marker) {
    icon = _marker.icon == _defaultIcon ? _clickIcon : _defaultIcon;
  }
  return icon;
}

/*
// Update the marker icon
*/
dashBoardMap.prototype.updateMarkerIcon = function (_modifyMarker, _icon, _zIndex) {
  if (_modifyMarker) {
    _modifyMarker.setOptions({
      icon: _icon,
      zIndex: _zIndex
    });
  }
}

// Convert ms to HMS format
dashBoardMap.prototype.msToHMS = function (duration) {
  var milliseconds = parseInt((duration % 1000) / 100),
    seconds = parseInt((duration / 1000) % 60),
    minutes = parseInt((duration / (1000 * 60)) % 60),
    hours = parseInt((duration / (1000 * 60 * 60)) % 24);
  hours = (hours < 10) ? "0" + hours : hours;
  minutes = (minutes < 10) ? "0" + minutes : minutes;
  seconds = (seconds < 10) ? "0" + seconds : seconds;
  return hours + ":" + minutes + ":" + seconds;
}

/*
// Set Zoom Level
*/
dashBoardMap.prototype.setZoomLevel = function (_zoomLevel) {
  this.zoomLevel = _zoomLevel;
}

/*
// call parent method EnableIconList
*/
dashBoardMap.prototype.parentEnableIconList = function (_method) {
  this.overLappingMarkerPopUp = _method;
}

/*
// call parent method parentDisableIcon
*/
dashBoardMap.prototype.parentDisableIcon = function (_method) {
  this.parentDisableIcon = _method;
}


/*
// close previous window
*/
dashBoardMap.prototype.previousInfoWindowClosed  = function () {
  const objInfoWindowMarker = this.infoWindowMarker? this.infoWindowMarker : null;
  if(objInfoWindowMarker){
    this.infoWindowClosed(objInfoWindowMarker);
    this.infoWindowMarker = null;
  }
}

/*
// range depend upon zoom level
*/
dashBoardMap.prototype.latlngRange  = function (_currentLat, _currentLng) {
  let zoom ;

  if(this.zoomLevel >= 7){
    zoom = zoomArea / (2 * (this.zoomLevel + 1));
  }
  else{
    zoom = zoomArea / (this.zoomLevel + 1);
  }

  //console.log("latlngRange --> zoom ", zoom);
  return zoom;
}

/*
// range data 
*/
dashBoardMap.prototype.rangeData  = function (_currentLat, _currentLng) {
  let incRange = this.latlngRange();
  let minLat =_currentLat - incRange;
  let maxLat = _currentLat + incRange;
  let minLng = _currentLng - incRange;
  let maxLng = _currentLng + incRange;
  let indexLatlng = _currentLat + "" + _currentLng ;
  //console.log("dashBoardMap.prototype.rangeData");

  const dataMarkerInstance = this.dataMarkerInstance;
  if (dataMarkerInstance && dataMarkerInstance.length) {
    const total = dataMarkerInstance.length;
    for (let inc = 0; inc < total; inc++) {
      const instance = dataMarkerInstance[inc];
      //console.log("inc --> ", inc);
      let marker1Lat = instance.marker1Coordinates ? instance.marker1Coordinates.lat : null;
      let marker1Lng = instance.marker1Coordinates ? instance.marker1Coordinates.lng : null;
      let marker2Lat = instance.marker2Coordinates ? instance.marker2Coordinates.lat : null;
      let marker2Lng = instance.marker2Coordinates ? instance.marker2Coordinates.lng : null;

      //console.log("minLat <=  marker1Lat && marker1Lat <=  maxLat " , minLat ,"<=",  marker1Lat ,"&&",  marker1Lat ,"<=",  maxLat);
      //console.log("minLng <= marker1Lng && marker1Lng <= maxLng ", minLng ,"<=", marker1Lng ,"&&", marker1Lng ,"<=", maxLng);
      if( marker1Lat &&  marker1Lng &&  (minLat <=  marker1Lat && marker1Lat <=  maxLat)  &&  (minLng <= marker1Lng && marker1Lng <= maxLng)  ) {
        if (!this.latLngData[indexLatlng].includes(instance.marker1Coordinates.id)) {
          this.latLngData[indexLatlng].push(instance.marker1Coordinates.id);
        }
      }

      //console.log("minLat <=  marker2Lat  && marker2Lat <=  maxLa t", minLat ,"<=",  marker2Lat  ,"&&", marker2Lat ,"<=",  maxLat);
      //console.log("minLng <= marker2Lng && marker2Lng <= maxLng ", minLng ,"<=", marker2Lng ,"&&", marker2Lng ,"<=", maxLng);
      if( marker2Lat &&  marker2Lng &&  (minLat <=  marker2Lat  && marker2Lat <=  maxLat)  &&  (minLng <= marker2Lng && marker2Lng <= maxLng)  ) {
        if (!this.latLngData[indexLatlng].includes(instance.marker2Coordinates.id)) {
          this.latLngData[indexLatlng].push(instance.marker2Coordinates.id);
        }
      }
    }
  }

  //sorting
  this.latLngData[indexLatlng].sort(this.sortingData);
  //console.log("this.latLngData --> ", this.latLngData);  
}

/*
// sorting data
*/
dashBoardMap.prototype.sortingData  = function(_rpid1, _rpid2){
    let rpid1 = _rpid1.toLowerCase();
    let rpid2 = _rpid2.toLowerCase();
    if (rpid1 < rpid2) //sort string ascending
        return -1 
    if (rpid1 > rpid2)//sort string descending
        return 1
    return 0 //default return value (no sorting)
}

/*
// Init the dashBoardMap 
*/
function init() {
  objectMap = new dashBoardMap('map-canvas');
  return objectMap;
}

export default init;


// WEBPACK FOOTER //
// ./src/map/script.js